import styled from 'styled-components';
import { IAnniversaryAnimateProps, ILoginWrapperProps } from './LoginPage-type';
import { black, exactWhite } from '../../utils/style/colors';

const anniversaryAnimationTransition = '1s';

export const LoginWrapper = styled.div<ILoginWrapperProps>`
  flex: 1;
  display: flex;
  min-height: fit-content;
  flex-direction: column;
  justify-content: center;
  background: ${(props) => `url(${props.background})`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;

export const LoginCardHolder = styled.div`
  width: 316px;
  display: flex;
  flex-direction: column;
  position: relative;
  align-self: center;
`;

export const AnniversaryNumber = styled.img<IAnniversaryAnimateProps>`
  position: absolute;
  top: ${({ showAnimation }) => {
    return showAnimation ? '-80px' : '-25px';
  }};
  transition: ${anniversaryAnimationTransition};
  left: 50%;
  z-index: 1;
`;

export const VectorImageTop = styled.img<IAnniversaryAnimateProps>`
  position: absolute;
  top: ${({ showAnimation }) => {
    return showAnimation ? '-40px' : '-60px';
  }};
  transition: ${anniversaryAnimationTransition};
  left: calc(50% - 46px);
  z-index: 2;
`;

export const VectorImageBottom = styled.img<IAnniversaryAnimateProps>`
  position: absolute;
  transition: ${anniversaryAnimationTransition};
  bottom: ${({ showAnimation }) => {
    return showAnimation ? '-261px' : '-241px';
  }};
  left: calc(50% - 46px);
`;

export const LangSelector = styled.div`
  position: absolute;
  right: 2rem;
  top: 2rem;
  width: 4rem;
  height: 4rem;
  background: ${black};
  color: ${exactWhite};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
`;

export const LangContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const LangItem = styled.div`
  padding: 0.5rem 0.75rem;
  color: ${black};
  cursor: pointer;
`;

export const VideoBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
  display: flex;
  align-items: center;
  justify-content: center;
`;
